import React from "react";
import { Alert, Button, Modal } from "antd";
import { useTranslation } from "react-i18next";

type SubmitModalPropType = {
  isopen: boolean;
  onclose: () => void;
  backToApplication: () => void;
  handleSubmit: () => void;
  isSubmitting: boolean;
  isSubmitError: boolean;
};

const SubmitModal: React.FC<SubmitModalPropType> = ({
  isopen,
  onclose,
  handleSubmit,
  isSubmitting,
  isSubmitError
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t("rating.submitModal.title")}
      open={isopen}
      onCancel={onclose}
      closable={false}
      footer={[
        <Button key="back" onClick={onclose} aria-label="Cancel the submission and close the modal">
          {t("rating.submitModal.cancelBtn")}
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={isSubmitting}
          onClick={handleSubmit}
          aria-label="Submit the ratings."
        >
          {t("rating.submitBtn")}
        </Button>
      ]}
    >
      {isSubmitError && (
        <Alert
          message="An error occurred while sending the request. Please try again."
          type="error"
          showIcon
          style={{ marginBottom: "1rem" }}
        />
      )}
      <p>{t("rating.submitModal.desc1")}</p>
      <br />
      <p>{t("rating.submitModal.desc2")}</p>
    </Modal>
  );
};

export default SubmitModal;
